import { render, staticRenderFns } from "./DialogAssignGroupStudentsToTrack.vue?vue&type=template&id=a0c34d00"
import script from "./DialogAssignGroupStudentsToTrack.vue?vue&type=script&lang=js"
export * from "./DialogAssignGroupStudentsToTrack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0c34d00')) {
      api.createRecord('a0c34d00', component.options)
    } else {
      api.reload('a0c34d00', component.options)
    }
    module.hot.accept("./DialogAssignGroupStudentsToTrack.vue?vue&type=template&id=a0c34d00", function () {
      api.rerender('a0c34d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAssignGroupStudentsToTrack.vue"
export default component.exports